import { useContext } from '@nuxtjs/composition-api'

export type McOrmFormModel = {
  fields: Record<string, string | number | boolean>
  files?: File | File[]
}

const useSendMcOrmEvent = () => {
  const context = useContext()
  return async ({ fields, files }: McOrmFormModel) => {
    try {
      const request = new FormData()
      request.append('fields', JSON.stringify(fields))

      const localFiles = files ? (Array.isArray(files) ? files : [files]) : []
      localFiles.forEach((file) => request.append('files[]', file, file.name))
      const response = await context.$api.requests.sendMcOrmEvent(request)
      return response.data?.success || false
    } catch (e) {
      console.error('SEND MC ORM EVENT ERROR', e)
    }
    return false
  }
}

export default useSendMcOrmEvent
